const getSorting = (sorting: { id: string; desc: boolean }[]) => {
  if (sorting.length > 0) {
    const [{ id, desc }] = sorting
    const order = desc ? 'desc' : 'asc'

    if (id === 'name') {
      return {
        sort: `lastName:${order},firstName:${order}`,
      }
    }

    return { sort: `${id}:${order}` }
  }

  return {}
}

const getFilters = (columnFilters: { id: string; value: string }[]) => {
  if (columnFilters.length > 0) {
    return {
      filters: columnFilters.reduce(
        (acc, { id, value }) => {
          if (id === 'name') {
            acc.$or = [
              { firstName: { $containsi: value } },
              { lastName: { $containsi: value } },
            ]
          } else {
            acc[id] = { $containsi: value }
          }
          return acc
        },
        {} as Record<string, any>
      ),
    }
  }

  return {}
}

export const getStrapiRequestParams = (
  pagination: { pageIndex: number; pageSize: number },
  sorting: Parameters<typeof getSorting>[0],
  filters: Parameters<typeof getFilters>[0]
) => ({
  pagination: {
    page: pagination.pageIndex + 1,
    pageSize: pagination.pageSize,
  },
  ...getSorting(sorting),
  ...getFilters(filters),
})
